import { useI18n } from "@/i18n";

export default function Ribbon() {
  const { t } = useI18n();
  const item = <span className="font-serif-display text-4xl md:text-6xl text-[#2C2520]/70 italic mr-24">{t.ribbon}</span>;
  return (
    <section className="bg-[#F2EFEB] border-y border-[#E5E0D8] py-12 marquee" data-testid="editorial-ribbon">
      <div className="marquee-track">
        {[...Array(4)].map((_, i) => (
          <span key={i} className="inline-flex">{item}</span>
        ))}
      </div>
    </section>
  );
}
